import { axios } from '@complispace/cs-design-system';

const assuranceBaseURL = process.env.ASSURANCE_API_URL;
const assuranceV1BaseURL = `${assuranceBaseURL}/api/v1`;

export default {
  // GET /api/v1/api-keys/validate
  async validateAssuranceApiKey(apiKey, tenantName) {
    const config = {
      headers: { 'x-api-key': apiKey, 'x-tenant': tenantName }
    };

    return axios.get(`${assuranceV1BaseURL}/api-keys/validate`, config);
  }
};
